import { Box, CloseButton, Flex, useColorModeValue } from '@chakra-ui/react';
import { AnimatePresence, motion } from 'framer-motion';
import * as React from 'react';

export const MobileNavContent = (props) => {
  const { isOpen, onClose, children } = props;
  const bg = useColorModeValue('white', 'gray.800');

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          transition={{
            duration: 0,
          }}
          initial={{
            opacity: 0,
          }}
          animate={{
            opacity: 1,
          }}
          exit={{
            opacity: 0,
          }}
        >
          <Flex
            pos='absolute'
            zIndex={20}
            top={0}
            left={0}
            alignContent='center'
            justify='space-between'
            direction='column'
            overflow='auto'
            w='100%'
            h='100vh'
            px={{ base: '1rem', md: '1.75rem', lg: '3rem', '2xl': '4.5rem' }}
            pt={{
              base: ' 1.75rem',
              md: '2rem',
              lg: '3.5rem',
              '2xl': '3.5rem',
            }}
            bg={bg}
          >
            <Box onClick={onClose}>{children}</Box>

            <CloseButton
              pos='absolute'
              top={{
                base: ' 1.25rem',
                md: '1.25rem',
                lg: '3.5rem',
                '2xl': '3.5rem',
              }}
              right={{
                base: '1.25rem',
                md: '1.75rem',
                lg: '3rem',
                '2xl': '4.5rem',
              }}
              color='amatrium.800'
              fontSize='24px'
              bg='transparent'
              onClick={onClose}
              variant='ghost'
            />
          </Flex>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
